import { palette } from '$tablet-app/src/app/theme';
import styled from 'styled-components/native';

const IconBackground = styled.View<{ color?: string }>`
  width: 62px;
  height: 62px;

  justify-content: center;
  align-items: center;

  background-color: ${({ color }) => color || palette.yellow_200};
  border-radius: 22px;
`;

export default IconBackground;
